export function detectMimeFromBase64(base64) {
  const cleaned = base64.replace(/^data:.*;base64,/, "");
  const binary = atob(cleaned);
  const bytes = Array.from(binary)
    .slice(0, 12)
    .map((c) => c.charCodeAt(0));
  const hex = bytes
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
    .toLowerCase();

  // Images
  if (hex.startsWith("89504e47")) return "image/png";
  if (hex.startsWith("ffd8ff")) return "image/jpeg";
  if (hex.startsWith("47494638")) return "image/gif";
  if (hex.startsWith("424d")) return "image/bmp";
  if (hex.startsWith("52494646") && cleaned.includes("WEBP"))
    return "image/webp";

  // Documents
  if (hex.startsWith("25504446")) return "application/pdf";
  if (hex.startsWith("7b5c727466")) return "application/rtf"; // "{\rtf"

  // ZIP-based (includes DOCX, XLSX, PPTX)
  if (hex.startsWith("504b0304")) return "application/zip";

  // Maybe text (JSON, TXT, XML)
  if (/^[\x20-\x7E\r\n\t]+$/.test(binary)) return "text/plain";

  return "application/octet-stream"; // fallback
}

export function base64ToDocxBlob(base64) {
  const cleaned = base64.replace(/^data:.*;base64,/, "");
  const byteCharacters = atob(cleaned);
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray = new Uint8Array(byteNumbers);

  return new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  });
}

export function addDataUrlPrefix(base64) {
  const cleaned = base64.replace(/^data:.*;base64,/, "");
  const mime = detectMimeFromBase64(cleaned);
  return `data:${mime};base64,${cleaned}`;
}
